import s from './ProductNotes.scss';
import { Translation } from 'react-i18next';
import * as React from 'react';
import { Text } from '@wix/design-system';

interface NoteProps {
  noteKey: string;
  dataHook: string;
  doubleNotes: boolean;
}

export const Note: React.FC<NoteProps> = ({
  noteKey,
  dataHook,
  doubleNotes,
}) => (
  <Translation>
    {(t) => (
      <div className={s.noteContainer} data-testid={dataHook}>
        <Text
          size='tiny'
          dataHook={dataHook}
          secondary={true}
          light={true}
          className={s.noteText}
          ellipsis={doubleNotes}
        >
          <i className={s.noteIcon} />
          {t(noteKey)}
        </Text>
      </div>
    )}
  </Translation>
);
